import { Wave } from '@/types/Wave';
import { IBuyerPersonasState } from './state';

export type SelectableBuyerPersona = Omit<BuyerPersona, 'ignore'> & {
  disabled: boolean;
};

export function buyerPersonas(
  state: IBuyerPersonasState,
  getters,
  rootState,
  rootGetters
): SelectableBuyerPersona[] {
  return state.buyerPersonas.map(({ ignore, ...buyerPersona }) => {
    let disabled = false;
    const year: Wave2 | Wave2[] = rootState.questions.lastSearch.year;

    if (ignore) {
      if (Array.isArray(year)) {
        if (year.some((wave) => ignore.since >= wave)) {
          disabled = true;
        }
      } else if (ignore.since >= year) {
        disabled = true;
      }
    }
    return {
      ...buyerPersona,
      disabled
    };
  });
}
